import { AgGridColumn, AgGridReact } from 'ag-grid-react';
import React from 'react';
import { Col, Row } from 'reactstrap';
import HeaderTitle from '../../../../../../../common/HeaderTitle';

const LevelFiveKys = () => {
    const rowData = [
        { serialNumber: 1, employeeCode: '2324 ', position: 'PURCHASE HEAD', approverName: "TIKAM SINGH", approvalLevel: "Work Flow Process:-1", requestDate: "12/06/2023", action: "Pending", actionDate: "-" },
        { serialNumber: 1, employeeCode: '2324 ', position: 'PURCHASE HEAD', approverName: "TIKAM SINGH", approvalLevel: "Work Flow Process:-1", requestDate: "12/06/2023", action: "Pending", actionDate: "-" },

        // Add more rows as needed
    ];
    return (
        <div className='hl-kys-two-wrap'>
            <Row className="ag-grid-react">
                <Col>
                    <div
                        className={`ag-grid-wrapper`}
                    >
                        <div
                            className={`ag-theme-material`}
                        >
                            <AgGridReact
                                style={{ height: "100%", width: "100%" }}
                                floatingFilter={true}
                                domLayout="autoHeight"
                                rowData={rowData}
                                rowSelection={"multiple"}
                                suppressRowClickSelection={true}
                                enableBrowserTooltips={true}
                                pagination={true}
                                pivotPanelShow={'always'}
                                paginationAutoPageSize={true}
                            >
                                <AgGridColumn
                                    cellClass="has-checkbox"
                                    headerName="S. No."
                                    field="serialNumber"
                                    floatingFilter={false}
                                    sortable={false}
                                // valueGetter={(params) => params.node.rowIndex + 1}
                                ></AgGridColumn>
                                <AgGridColumn
                                    field="employeeCode"
                                    floatingFilter={false}
                                    headerName="Employee Code"
                                // cellRenderer={checkBoxRenderer}
                                ></AgGridColumn>
                                <AgGridColumn
                                    field="position"
                                    floatingFilter={false}
                                    headerName="Position"
                                // cellRenderer={checkBoxRenderer}
                                ></AgGridColumn>

                                <AgGridColumn
                                    headerName="Approver Name"
                                    sortable={false}
                                    field='approverName'
                                    floatingFilter={false}
                                // tooltipComponent={'customTooltip'}
                                ></AgGridColumn>

                                <AgGridColumn
                                    headerName="Approval Level"
                                    sortable={false}
                                    field='approvalLevel'
                                    floatingFilter={false}
                                // tooltipComponent={'customTooltip'}
                                ></AgGridColumn>
                                <AgGridColumn
                                    headerName="Request Date"
                                    field='requestDate'
                                    sortable={false}
                                    floatingFilter={false}
                                // tooltipComponent={'customTooltip'}
                                ></AgGridColumn>
                                <AgGridColumn
                                    headerName="Action"
                                    field='action'
                                    sortable={false}
                                    floatingFilter={false}
                                // tooltipComponent={'customTooltip'}
                                ></AgGridColumn>
                                <AgGridColumn
                                    headerName="Action Date"
                                    field='actionDate'
                                    sortable={false}
                                    floatingFilter={false}
                                // tooltipComponent={'customTooltip'}
                                ></AgGridColumn>
                            </AgGridReact>
                        </div>
                    </div>
                </Col>
            </Row>
            <Row className="justify-content-between sf-btn-footer no-gutters justify-content-between bottom-footer sticky-btn-footer hl-btm-footer">
                <div className="col-sm-12 text-right bluefooter-butn">
                <button
                        type="button"
                        className="submit-button save-btn mr5"
                    >
                        <div className="send-for-approval mr-1"></div>
                        {"Request Review"}
                    </button>
                    <button
                        type={"button"}
                        className="mr5 approve-reject-btn"
                    >
                        <div className={"cancel-icon"}></div>
                        {"Reject"}
                    </button>

                    <button
                        type="submit"
                        className="approve-button approve-hover-btn"

                    >
                        <div className={"cancel-icon-white mr5"}></div>
                        {"Approve"}
                    </button>

                    
                </div>

            </Row>
        </div>
    )
}

export default LevelFiveKys;
